import React from "react";
import { HexGrid, Layout, Hexagon } from "react-hexgrid";
import { useTheme } from "../../context/ThemeContext";

const HoneycombCluster: React.FC = () => {
  const { theme } = useTheme();

  if (theme === "light") {
    return null;
  }

  const hexColor = "#F57E0C";

  const hexagons = [
    { q: 0, r: 0, s: 0 },
    { q: 1, r: -1, s: 0 },
    { q: 1, r: 0, s: -1 },
    { q: 0, r: 1, s: -1 },
    { q: -1, r: 1, s: 0 },
    { q: -1, r: 0, s: 1 },
    { q: 2, r: -1, s: -1 },
    { q: 2, r: 0, s: -2 },
    { q: 1, r: 1, s: -2 },
    { q: 0, r: 2, s: -2 },
    { q: -1, r: 2, s: -1 },
    { q: 3, r: -1, s: -2 },
    { q: 3, r: -2, s: -1 },
    { q: 2, r: -2, s: 0 },
    { q: -1, r: 3, s: -2 },
    { q: -2, r: 2, s: 0 },
  ];

  return (
    <div
      className="fixed bottom-0 right-0 pointer-events-none overflow-visible z-50"
      style={{
        width: "350px",
        height: "350px",
        transform: "translate(32%, 43%)",
      }}
    >
      <HexGrid width={350} height={350} viewBox="-28 -28 56 56">
        <Layout
          size={{ x: 3, y: 3 }}
          flat={false}
          spacing={1.1}
          origin={{ x: 0, y: 0 }}
        >
          {hexagons.map((hex, idx) => (
            <Hexagon
              key={idx}
              q={hex.q}
              r={hex.r}
              s={hex.s}
              style={{
                fill: hexColor,
                stroke: "none",
                opacity: 0.2,
              }}
            />
          ))}
        </Layout>
      </HexGrid>
    </div>
  );
};

export default HoneycombCluster;
